<template>
    <SidebarChild :selected-item="value" :items="menuItems" :focusActive="true" @selected="selectedItem" />
</template>
<script>
import SidebarChild from "../../../../../components/Sidebar/SidebarChild.vue";
import WebChatMenuTypes from "./WebChatMenuTypes";
import { mapGetters, mapState } from "vuex";

export default {
    name: "WebChatMenuTypes",
    components: {
        SidebarChild,
    },
    props: {
        value: {
            type: String,
            default: null,
        },
    },
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
        }),
        ...mapGetters({
            checkPermission: "auth/checkPermission",
        }),
        menuItems() {
            return WebChatMenuTypes(this);
        },
    },
    methods: {
        selectedItem({ key }) {
            this.$emit("input", key);
        },
    },
};
</script>
